import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "p-2" }
const _hoisted_2 = ["href"]
const _hoisted_3 = ["textContent"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["textContent"]

import { onBeforeMount, ref, toRefs } from 'vue';
import Menu from 'primevue/menu';
import { useToast } from 'primevue/usetoast';
import { AxiosResponse } from 'axios';
import { useArchiveStore, useAuthStore } from '@/store';
import { PERMISSIONS } from '@/enum';
import { can } from '@/composables';


export default /*@__PURE__*/_defineComponent({
  __name: 'UserListActions',
  props: {
  data: {
    type: Object,
    default: undefined,
  },
},
  emits: ['onArchived'],
  setup(__props, { emit: __emit }) {

const emit = __emit;
const authStore = useAuthStore();
const archiveStore = useArchiveStore();

const toast = useToast();

const props = __props;

const { data } = toRefs(props);
const menu = ref();
const reasonId = ref();
const confirmArchiveOpen = ref(false);
const loading = ref(false);

let impersonateDebounce = false;

onBeforeMount(() => init());

const onImpersonate = async () => {
  if (impersonateDebounce) return;

  impersonateDebounce = true;

  await authStore.impersonate(data?.value?.id as number);

  if (authStore.error) {
    doFail(authStore.error);
    authStore.error = undefined;
    impersonateDebounce = false;
  }
};

const init = () => {
  loading.value = false;
  confirmArchiveOpen.value = false;
  reasonId.value = false;
};

const openConfirmArchive = () => {
  archiveStore.person = {
    id: data?.value?.id as number,
    display_name: data?.value?.full_name as string,
    archived_at: data?.value?.archived_at as string,
    people_type: {
      acronym: data?.value?.people_type.acronym as string,
    },
  };
  archiveStore.isShow = true;
};

const doToastUnarchive = (response: AxiosResponse) => {
  const success = response.status === 200;

  toast.add({
    severity: success ? 'success' : 'error',
    summary: success ? 'Unarchived' : 'Error',
    detail: success ? 'User Unarchived.' : response.statusText,
    life: 3000,
  });
};

const onUnarchivePerson = async () => {
  const response = await archiveStore.unarchive(data?.value?.id);

  if (response.status === 200) {
    emit('onArchived');
  }

  doToastUnarchive(response);
};

const menuItems = (() => {
  return [
    {
      label: 'View Profile',
      icon: {
        name: 'person',
        styles: 'inline-block text-lg text-blue-500',
      },
      styles: '',
      url: `/user/${data?.value?.id}`,
      visible: can([PERMISSIONS.PEOPLE_SHOW]),
    },
    {
      label: 'Impersonate',
      icon: {
        name: 'fingerprint',
        styles: 'inline-block text-lg text-purple-500',
      },
      command: onImpersonate,
      visible:
        !authStore.isImpersonating &&
        !!data?.value?.user &&
        !data?.value?.archived_at &&
        can([PERMISSIONS.IMPERSONATE]),
    },
    {
      label: 'Archive',
      icon: {
        name: 'vpn_key',
        styles: 'inline-block text-lg text-orange-500',
      },
      command: openConfirmArchive,
      visible: data?.value?.archived_at === null && can([PERMISSIONS.PEOPLE_ARCHIVE]),
    },
    {
      label: 'Unarchive',
      icon: {
        name: 'unarchive',
        styles: 'inline-block text-lg text-orange-500',
      },
      command: onUnarchivePerson,
      visible: data?.value?.archived_at != null && can([PERMISSIONS.PEOPLE_UNARCHIVE]),
    },
  ];
})();

const toggle = (event: Event): void => menu.value.toggle(event);

const doFail = (detail: string) => {
  toast.add({
    severity: 'error',
    summary: 'Error',
    detail: detail,
    life: 3000,
  });
};

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: "ml-3 cursor-pointer",
    onClick: toggle
  }, [
    _createVNode(_component_Icon, {
      name: "more_horiz",
      class: "text-lg p-1"
    }),
    _createVNode(_unref(Menu), {
      id: "overlay_menu",
      ref_key: "menu",
      ref: menu,
      class: "mt-2 ml-2 p-2",
      model: _unref(menuItems),
      popup: true
    }, {
      item: _withCtx(({ item }) => [
        _createElementVNode("div", _hoisted_1, [
          (item.url)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: item.url
              }, [
                _createVNode(_component_Icon, {
                  name: item.icon?.name,
                  class: _normalizeClass(item.icon.styles)
                }, null, 8, ["name", "class"]),
                _createElementVNode("span", {
                  class: "relative inline-block ml-2 text-sm text-800",
                  textContent: _toDisplayString(item.label)
                }, null, 8, _hoisted_3)
              ], 8, _hoisted_2))
            : _createCommentVNode("", true),
          (item.command)
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                onClick: ($event: any) => (item.command())
              }, [
                _createVNode(_component_Icon, {
                  name: item.icon.name,
                  class: _normalizeClass(item.icon.styles)
                }, null, 8, ["name", "class"]),
                _createElementVNode("span", {
                  class: "relative inline-block ml-2 text-sm text-800",
                  textContent: _toDisplayString(item.label)
                }, null, 8, _hoisted_5)
              ], 8, _hoisted_4))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["model"])
  ]))
}
}

})